import { IconProps } from '../types';

const IcPlay = (props: IconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill="rgba(0, 0, 0, 0.5)" />
    <path
      d="M32 24L20 32V16L32 24Z"
      fill="white"
    />
  </svg>
);

export default IcPlay;
